import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import classes from "./SelectedAppointment.module.scss";
import ButtonComponent from "../../ButtonComponent";
import { COLORS } from "../../../lib/colors";
import ChatIcon from "@mui/icons-material/Chat";
import VideocamIcon from "@mui/icons-material/Videocam";
import CallIcon from "@mui/icons-material/Call";
import InfoIcon from "@mui/icons-material/Info";
import { useUserState } from "../../../providers/UserProvider";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import PrescriptionModal from "../../AppointmentRoom/RoomHeader/PrescriptionModal";
import DocumentsModal from "../../AppointmentRoom/RoomHeader/DocumentsModal";

// import { ReactComponent as AngleBracketIcon } from "../../assets/images/angleBracketIcon.svg";

function SelectedAppointment({
  onVideoCall,
  onPrivateCall,
  closeSelectedItem,
  image,
  name,
  title,
  link,
  chatBtnBackColor,
  textColor,
  chatBtnTxt,
  onSelectAppointment,
  audienceId,
  visitToken,
  onPatientVideoCallRequest,
  onlineMembers,
  item,
}) {
  const { t } = useTranslation();
  const user = useUserState();
  let userType = user?.user_login?.approve;

  const [openPrescriptions, setOpenPrescriptions] = useState(false);
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false);
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    if (userType && userType === "user" && onlineMembers) {
      let onlineItem = onlineMembers.filter(
        (element) => element.id === item.dr_info.doctor_key
      );
      if (onlineItem.length === 1) {
        setIsOnline(true);
      }
    }
    if (userType && userType === "doctor" && onlineMembers) {
      let onlineItem = onlineMembers.filter(
        (element) => element.id === item.user_info.user_key
      );
      if (onlineItem.length === 1) {
        setIsOnline(true);
      }
    }
  }, [item, item?.dr_info?.doctor_key, onlineMembers, userType]);

  const renderActionBtns = () => {
    if (userType === "doctor") {
      return (
        <div className={classes.btnContainer}>
          <Link
            className={classes.actionButtons}
            style={{ textDecoration: "none" }}
            to={link}
          >
            <ButtonComponent
              textColor={textColor}
              backgroundColor={chatBtnBackColor}
              icon={<ChatIcon />}
              onClick={onSelectAppointment}
              className={classes.drActionBtn}
            >
              {chatBtnTxt}
            </ButtonComponent>
          </Link>
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<VideocamIcon />}
            onClick={onVideoCall}
            className={classes.actionButtons}
          >
            {t("components.Layout.SelectedAppointment.doctor.videoCall")}
          </ButtonComponent>
          <ButtonComponent
            className={classes.actionButtons}
            backgroundColor={COLORS.purple}
            icon={<CallIcon />}
            onClick={onPrivateCall}
          >
            {t("components.Layout.SelectedAppointment.doctor.privateCall")}
          </ButtonComponent>
          <ButtonComponent
            className={classes.actionButtons}
            backgroundColor={COLORS.purple}
            //   icon={<AboutAndInfoIcon />}
            icon={<InfoIcon />}
          >
            {t("components.Layout.SelectedAppointment.doctor.about")}
          </ButtonComponent>
        </div>
      );
    }
    if (userType === "user") {
      return (
        <div className={classes.btnContainer}>
          <Link
            className={classes.actionButtons}
            style={{ textDecoration: "none" }}
            to={link}
          >
            <ButtonComponent
              textColor={textColor}
              backgroundColor={chatBtnBackColor}
              icon={<ChatIcon />}
              onClick={onSelectAppointment}
            >
              {chatBtnTxt}
            </ButtonComponent>
          </Link>
          <ButtonComponent
            backgroundColor={COLORS.primary}
            icon={<VideocamIcon />}
            // onClick={onPatientVideoCallRequest}
            textColor={COLORS.purple}
            className={classes.actionButtons}
            // width="100%"
          >
            about Dr
          </ButtonComponent>
          <div style={{ width: "100%" }}>
            <ButtonComponent
              backgroundColor={COLORS.primary}
              icon={<VideocamIcon />}
              onClick={onPatientVideoCallRequest}
              className={classes.actionButtons}
              textColor={COLORS.purple}
              fullWidth
            >
              {t("components.Layout.SelectedAppointment.user.videoCall")}
            </ButtonComponent>
          </div>
          {/* <ButtonComponent
            className={classes.actionButtons}
            backgroundColor={COLORS.primary}
            icon={<InfoIcon />}
            onClick={() => {
              setOpenDocumentsModal(true);
            }}
          >
            {t("components.Layout.SelectedAppointment.user.sendDoc")}
          </ButtonComponent>
          <ButtonComponent
            className={classes.actionButtons}
            backgroundColor={COLORS.primary}
            //   icon={<AboutAndInfoIcon />}
            icon={<InfoIcon />}
            onClick={() => {
              setOpenPrescriptions(true);
            }}
          >
            {t("components.Layout.SelectedAppointment.user.prescription")}
          </ButtonComponent> */}
        </div>
      );
    }
  };

  const renderCounter = () => {
    switch (userType) {
      case "user":
        if (item && item.dr_info.chat_count !== 0) {
          return (
            <div
              className={
                !isOnline
                  ? classes.messageCounter
                  : classes.onlineMessageCounter
              }
            >
              {item.dr_info.chat_count}
            </div>
          );
        }
        break;
      case "doctor":
        if (item && item.user_info.chat_count !== 0) {
          return (
            <div
              className={
                !isOnline
                  ? classes.messageCounter
                  : classes.onlineMessageCounter
              }
            >
              {item.user_info.chat_count}
            </div>
          );
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.mainContainer}>
      <IconButton onClick={closeSelectedItem} aria-label="delete">
        <FullscreenExitIcon />
      </IconButton>
      <div className={classes.imageContainer}>
        <div className={classes.counterContainer}>{renderCounter()}</div>
        <img src={image} className={classes.userImg} alt="user" />
      </div>
      <div className={classes.textContainer}>
        <h3>{name}</h3>
        {userType === "user" && <p>{title}</p>}
        <p>{item.event_list[0].data}</p>
      </div>
      {/* <div className={classes.btnContainer}> */}

      {renderActionBtns()}
      <PrescriptionModal
        handleOpenPrescriptions={openPrescriptions}
        handleClosePrescriptions={() => setOpenPrescriptions(false)}
        audienceId={audienceId}
        visitToken={visitToken}
      />
      <DocumentsModal
        handleOpenDocuments={openDocumentsModal}
        handleCloseDocuments={() => setOpenDocumentsModal(false)}
        audienceId={audienceId}
        visitToken={visitToken}
      />
      {/* </div> */}
    </div>
  );
}

export default SelectedAppointment;
